import type { SkFont } from "@shopify/react-native-skia";

/**
 * Web implementation of safe font loading.
 * Returns null since Skia fonts are not supported on web.
 * @param _size - Font size (unused on web)
 * @returns Always null on web
 */
export const useSafeFont = (_size: number): SkFont | null => null;
